import { LOAD_COURSES_DETAILS, SWITCH_COURSE_REQUEST, SWITCH_COURSE, TOGGLE_SWITCH_COURSE_MODAL, SWITCH_LESSON_REQUEST, SWITCH_LESSON, TOGGLE_SWITCH_LESSON_MODAL } from '../constants';

export function loadCourseDetails(userId, courseCode) {
	return {
		type: LOAD_COURSES_DETAILS,
		payload: { userId, courseCode },
	}
}

export function toggleCourseConfirmationModal() {
	return {
		type: TOGGLE_SWITCH_COURSE_MODAL
	}
}

export function switchCourseRequest() {
	return {
		type: SWITCH_COURSE_REQUEST
	}
}

/**
 * @param {String} courseCode
 * @param {{ unitId: String, lessonId: String }} [startAt] where to start the course (LMSNEXT-1276)
 */
export function switchCourse(courseCode, startAt) {
	return {
		type: SWITCH_COURSE,
		courseCode: courseCode,
		startAt: startAt,
	}
}

export function toggleLessonConfirmationModal() {
	return {
		type: TOGGLE_SWITCH_LESSON_MODAL
	}
}

export function switchLessonRequest() {
	return {
		type: SWITCH_LESSON_REQUEST
	}
}

export function switchLesson(courseCode) {
	return {
		type: SWITCH_LESSON,
		courseCode: courseCode,
	}
}